<template>
    <div>
        <!-- <div class="queryPanel">
            <div class="queryPanel_form" :class="{'queryPanel_form_show': showForm}">
                <Form 
                    :form="queryForm" 
                    @handleSelectChange="handleSelectChange"
                    @handlePressEnter="handlePressEnter"
                    @handleInputClear=handleInputClear
                    @handlePickerDateChange="handlePickerDateChange"
                ></Form>
            </div>
            <div class="queryPanel_btn">
                <a-dropdown-button size="small" @click="handle('search')">
                    <icon-search size="14" style="marginRight:5px;"/>
                    {{ $t('base.search') }}
                    <template #content>
                        <a-doption @click="handle('reset')">
                            <icon-refresh size="14" style="marginRight:5px;"/>
                            {{ $t('base.reset') }}
                        </a-doption>
                    </template>
                </a-dropdown-button>
                <span class="openBtn" v-if="!showForm" @click="showFormPanel(true)">
                    <icon-down-circle size="14"/>
                    {{ $t('base.open') }}
                </span>
                <span class="openBtn" v-else @click="showFormPanel(false)">
                    <icon-up-circle size="14" />
                    {{ $t('base.close') }}
                </span>
            </div>
        </div> -->

        <Table
            :table="table"
        >
            <template v-slot:operate>
                <a-button type="primary" size="mini" @click="handle('refreshList')">
                    <icon-refresh size="13" style="marginRight:5px;"/>
                    {{ $t('inventoryLock.refresh') }}
                </a-button>
                <a-divider direction="vertical" v-permission="'setting.inventoryLock.exportExcel'" />
                <a-button type="primary" size="mini" v-permission="'setting.inventoryLock.exportExcel'" :disabled="exporting" @click="exportFile">
                    <icon-download size="13" style="marginRight:5px;"/>
                    {{ $t('dealerOpenOrder.exportExcel') }}
                </a-button>
                
            </template>

            <template v-slot:tableOperate="{ props }">
                <a-button 
                    v-permission="'setting.inventoryLock.editLock'"
                    type="primary" 
                    size="mini" 
                    @click="handle('edit',props.record)"
                >
                    <icon-edit size="13" style="marginRight:5px;"/>
                    {{ $t('base.edit') }}
                </a-button>
                <a-divider direction="vertical"/> 
                <a-button 
                    v-permission="'setting.inventoryLock.viewLock'"
                    type="primary" 
                    status="success" 
                    size="mini" 
                    @click="handle('view',props.record)"
                >
                    <icon-message size="13" style="marginRight:5px;"/>
                    {{ $t('inventoryLock.view') }}
                </a-button>
            </template>

            <template v-slot:searchFilter="{ props }">
                <div class="searchFilter">
                    <a-space direction="vertical">
                    <a-input :model-value="props.filterValue[0]" style="width:164px" @input="(value)=>props.setFilterValue([value])" />
                    <div class="searchFilter-footer">
                        <a-button style="margin-right:10px" @click="props.handleFilterReset">{{ $t('base.reset') }}</a-button>
                        <a-button type="primary" @click="props.handleFilterConfirm">{{ $t('base.confirm2') }}</a-button>
                    </div>
                    </a-space>
                </div>
            </template>
        </Table>

        <!-- view -->
        <a-drawer width="90%" :visible="visible" :footer="null" unmountOnClose @cancel="visible = false">
            <template #title>{{ $t('inventoryLock.inventoryLockInfo') }}</template>
            <div>
                <Form 
                    :form="queryForm2"
                    @handleSelectChange="handleViewSelectChange"
                    @handlePressEnter="handleViewPressEnter"
                    @handleInputClear=handleViewInputClear
                ></Form>

                <Table 
                    :table="viewTable"
                    @changePage="changePage"
                    @changePageSize="changePageSize"
                >
                    <template v-slot:columns="{props}">
                        <div v-if="props.column.key == 'lock_status'">
                            <a-tag :color="props.record.lock_status_val == 0? 'red' : props.record.lock_status_val == 1? 'orange' : 'green' ">{{ props.record.lock_status }}</a-tag>
                        </div> 
                    </template>
                </Table>
            </div>
        </a-drawer>


        <!-- edit -->
        <a-drawer 
            width="90%" 
            :visible="editVisible" 
            :okText="t('base.save')"
            :maskClosable="false"
            :closable="false"
            @ok="handleOk"
            @cancel="handleCancel" 
            unmountOnClose
        >
            <template #title>{{ rowData.sku }}</template>

            <div class="tableTitle">
                {{ $t('inventoryLock.avaInventoryList') }} 
                <a-button type="primary" size="mini" style="float:right" @click="handle('refresh')">
                    <icon-refresh size="13" style="marginRight:5px;"/>
                    {{ $t('inventoryLock.refresh') }}
                </a-button>
            </div>
            <Table 
                class="editTable"
                :table="editTable"
            ></Table>


            <div class="tableTitle" style="margin-top: 20px"> {{ $t('inventoryLock.orderInventoryLockList') }} </div>
            <div class="toolBar">
                <a-select 
                    v-model="order_no"
                    :style="{width:'250px'}" 
                    :options="orderOptions"
                    allow-search
                    placeholder="Please select order no."
                    @change="changeOrderNo"
                ></a-select>    

                <a-button v-permission="'setting.inventoryLock.addLockLine'" type="primary" size="small" :disabled="!order_no || editLockTable.datas.length == editTable.datas.length" style="margin-left:15px;" @click="handle('addLockLine')">
                    <icon-plus size="13" style="marginRight:5px;"/>
                    {{ $t('base.add') }}
                </a-button>
                <a-button v-permission="'setting.inventoryLock.editLockLine'" type="primary" size="small" :disabled="editLockTable.datas.length == 0" style="margin-left:15px;" @click="handle('editInventoryLock')">
                    <icon-edit size="13" style="marginRight:5px;"/>
                    {{ $t('base.edit') }}
                </a-button>
                <a-button v-permission="'setting.inventoryLock.unlockInventory'" type="primary" status="danger" size="small" :disabled="editLockTable.datas.length == 0" style="margin-left:15px;" @click="handle('unlockInventory')">
                    <icon-unlock size="13" style="marginRight:5px;"/>
                    {{ $t('inventoryLock.unlockInventory') }}
                </a-button>
                <span style="font-size:16px; font-weight:bold; margin-left:30px">{{ $t('inventoryLock.skuOrderQty') }}{{ total_quantity }}</span>
                <span style="font-size:16px; font-weight:bold; margin-left:30px">{{ $t('inventoryLock.openQty') }}{{ open_quantity }}</span>
            </div>

            <Table 
                class="editTable"
                :table="editLockTable"
            >
                <template v-slot:columns="{props}">
                    <div v-if="props.column.key == 'inventory_type'">
                        <a-select 
                            v-model="props.record.inventory_type"
                            :style="{width:'160px'}" 
                            :disabled="props.record.disabled1"
                            :options="inventoryTypeOptions"
                            @change="(val)=>changeInventoryType(val, props.record)"
                        ></a-select>
                    </div> 
                    <div v-if="props.column.key == 'plan_timestamp'">
                        <a-select 
                            v-model="props.record.plan_timestamp"
                            :style="{width:'180px'}" 
                            :disabled="props.record.disabled2"
                            :options="props.record.planTimestampOptions"
                            @change="(val)=>changePlanTimestamp(val, props.record)"
                        ></a-select>
                    </div> 
                    <div v-if="props.column.key == 'warehouse'">
                        <a-select 
                            v-model="props.record.warehouse"
                            :style="{width:'170px'}" 
                            :disabled="props.record.disabled3"
                            :options="props.record.warehouseOptions"
                            @change="(val)=>changeWarehouse(val, props.record)"
                        ></a-select>
                    </div> 
                    <div v-if="props.column.key == 'batch_id'">
                        <a-select 
                            v-model="props.record.batch_id"
                            :style="{width:'250px'}" 
                            :disabled="props.record.disabled4"
                            :options="props.record.batchIdOptions"
                            @change="(val)=>changeBatchId(val, props.record)"
                        ></a-select>
                    </div> 
                    <div v-if="props.column.key == 'need_plan_timestamp'">
                        <a-date-picker 
                            v-model="props.record.need_plan_timestamp" 
                            style="width: 210px;" 
                            :disabled="props.record.edit_disabled"
                            :disabledDate="(current) => disabledDate(current, props.record)"
                            @change="(val)=>changeDate(val, props.record)"
                        />
                    </div> 
                    <div v-if="props.column.key == 'quantity'">
                        <a-input-number 
                            v-model="props.record.quantity" 
                            style="width:140px" 
                            class="input-demo" 
                            hide-button
                            :min="props.record.reserved_quantity > 0? 0 : 1" 
                            :disabled="props.record.edit_disabled"
                            @change="(val)=>changeQuantity(val, props.record)"
                        />
                    </div> 
                </template>

                <template v-slot:tableOperate="{ props }">
                    <a-button v-permission="'setting.inventoryLock.deleteLockLine'" type="primary" size="mini" status="danger" :disabled="props.record.delete_disabled" @click="handleDeleteLine(props.record)">
                        <icon-delete size="13" style="marginRight:5px;"/>
                        {{ $t('base.delete') }}
                    </a-button>
                </template>
            </Table>
        </a-drawer>


    </div>
</template>

<script setup>
    import { onMounted, reactive, ref, watch, nextTick, h } from 'vue';
    import { InventoryLockApi } from '@/api/InventoryLockApi.js';
    import { Message, Modal } from '@arco-design/web-vue';
    import Table from '@/components/Table.vue';
    import Form from '@/components/Form.vue';
    import { InventoryLockListQuery, ViewListQuery } from './queryConfig/InventoryLockListQuery.js';
    import { useI18n } from 'vue-i18n';
    import { useLocale } from '@/store/index.js';
    import { IconSearch } from '@arco-design/web-vue/es/icon';
    import { dateToTimestamp, timestampToDate, getNowDate } from '@/utils/index.js';
    import dayjs from 'dayjs';

    const localeStore = useLocale()

    const { t } = useI18n()


    const queryForm = reactive(InventoryLockListQuery)
    const queryForm2 = reactive(ViewListQuery)
    const showForm = ref(false)
    const visible = ref(false)
    const editVisible = ref(false)
    const rowData = ref(null)
    const order_no = ref('')
    const order_line_id = ref('')
    const orderOptions = ref([])
    const total_quantity = ref(0)
    const open_quantity = ref(0)
    const type_plan_wms = ref([])
    const exporting = ref(false)

    const table = ref({
        datas:[],
        columns:[
            {
                title: '#',
                dataIndex: 'No',
                key:'No',
                width:'60',
                fixed:'left',
                align:'left',
            },
            {
                // title: '',
                title: t('inventoryLock.sku'),
                dataIndex: 'sku',
                key:'sku',
                width:'190',
                ellipsis:true,
                tooltip:true,
                fixed:'left',
                align:'left',
                filterable: {
                    filter: (value, record) => record.sku.includes(value),
                    slotName: 'searchFilter',
                    icon: () => h(IconSearch)
                }
            },
            {
                // title: '',
                title: t('inventoryLock.total'),
                dataIndex: 'total_inventory',
                key:'total_inventory',
                width:'150',
                ellipsis:true,
                tooltip:true,
                align:'left',
                filterable: {
                    filters: [{
                        text: '> 0',
                        value: '0',
                    }],
                    filter: (value, row) => row.total_inventory > 0,
                }
            },
            {
                // title: '',
                title: t('inventoryLock.inStock'),
                dataIndex: 'in_stock_inventory',
                key:'in_stock_inventory',
                width:'180',
                ellipsis:true,
                tooltip:true,
                align:'left',
                filterable: {
                    filters: [{
                        text: '> 0',
                        value: '0',
                    }],
                    filter: (value, row) => row.in_stock_inventory > 0,
                }
            },
            {
                // title: '',
                title: t('inventoryLock.inTransit'),
                dataIndex: 'in_transit_inventory',
                key:'in_transit_inventory',
                width:'150',
                ellipsis:true,
                tooltip:true,
                align:'left',
                filterable: {
                    filters: [{
                        text: '> 0',
                        value: '0',
                    }],
                    filter: (value, row) => row.in_transit_inventory > 0,
                }
            },
            {
                // title: '',
                title: t('inventoryLock.productionPlan'),
                dataIndex: 'planned_production_inventory',
                key:'planned_production_inventory',
                width:'170',
                ellipsis:true,
                tooltip:true,
                align:'left',
                filterable: {
                    filters: [{
                        text: '> 0',
                        value: '0',
                    }],
                    filter: (value, row) => row.planned_production_inventory > 0,
                }
            },
            {
                // title: '',
                title: t('inventoryLock.availableQTY'),
                dataIndex: 'availability_inventory',
                key:'availability_inventory',
                width:'170',
                ellipsis:true,
                tooltip:true,
                align:'left',
                filterable: {
                    filters: [{
                        text: '> 0',
                        value: '0',
                    }],
                    filter: (value, row) => row.availability_inventory > 0,
                }
            },
            {
                // title: '',
                title: t('inventoryLock.lockedQTY'),
                dataIndex: 'locked_inventory',
                key:'locked_inventory',
                width:'130',
                ellipsis:true,
                tooltip:true,
                align:'left',
                filterable: {
                    filters: [{
                        text: '> 0',
                        value: '0',
                    }],
                    filter: (value, row) => row.locked_inventory > 0,
                }
            },
            {
                title: t('base.operate'),
                dataIndex: 'Optional',
                key:'Optional',
                slotName:'optional',
                width:'210',
                align:'center',
                fixed:'right'
            }
        ],
        configs:{
            scroll:{
                x:1000,
                y:650,
            },
            stripe:true,
            bordered:true,
            size:'large',
            loading:false,
            expandable:'',
            expand:false,
            pagination:false,
        },
    })

    const viewTable = ref({
        datas:[],
        columns:[
            {
                title: '#',
                dataIndex: 'No',
                key:'No',
                width:'60',
                fixed:'left',
                align:'left',
            },
            {
                // title: '',
                title: t('inventoryLock.orderName'),
                dataIndex: 'order_name',
                key:'order_name',
                width:'140',
                ellipsis:true,
                tooltip:true,
                fixed:'left',
                align:'left',
            },
            {
                // title: '',
                title: t('inventoryLock.sku'),
                dataIndex: 'sku',
                key:'sku',
                width:'190',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            {
                // title: '',
                title: t('inventoryLock.type'),
                dataIndex: 'inventory_type',
                key:'inventory_type',
                width:'160',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            {
                // title: '',
                title: t('inventoryLock.warehouse'),
                dataIndex: 'warehouse',
                key:'warehouse',
                width:'170',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            {
                // title: '',
                title: t('inventoryLock.lockStatus'),
                dataIndex: 'lock_status',
                key:'lock_status',
                width:'120',
                ellipsis:true,
                tooltip:true,
                align:'left',
                slotName:'slot'
            },
            {
                // title: '',
                title: t('inventoryLock.totalLockedQTY'),
                dataIndex: 'locked_quantity',
                key:'locked_quantity',
                width:'150',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            {
                // title: '',
                title: t('inventoryLock.currentLockedQTY'),
                dataIndex: 'quantity',
                key:'quantity',
                width:'180',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            {
                // title: '',
                title: t('inventoryLock.shippingQTY'),
                dataIndex: 'reserved_quantity',
                key:'reserved_quantity',
                width:'150',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            {
                // title: '',
                title: t('inventoryLock.estimatedShippingDate'),
                dataIndex: 'plan_timestamp',
                key:'plan_timestamp',
                width:'220',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            {
                // title: '',
                title: t('inventoryLock.estimatedShippingDateByCustomer'),
                dataIndex: 'need_plan_timestamp',
                key:'need_plan_timestamp',
                width:'300',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            {
                // title: '',
                title: t('inventoryLock.batchId'),
                dataIndex: 'batch_id',
                key:'batch_id',
                width:'220',
                ellipsis:true,
                tooltip:true,
                align:'left',
            }
        ],
        configs:{
            scroll:{
                // x:1000,
                y:650,
            },
            stripe:true,
            bordered:true,
            size:'large',
            loading:false,
            expandable:'',
            expand:false,
            pagination:{
                size:'mini',
                current:1,
                pageSize:10,
                total:0,
                pageSizeOptions:[10, 20, 50, 100],
                showJumper:true,
                showPageSize:true,
                showTotal:true,
            },
        },
    })

    const editTable = ref({
        datas:[],
        columns:[
            {
                title: '#',
                dataIndex: 'No',
                key:'No',
                width:'60',
                fixed:'left',
                align:'left',
            },
            {
                // title: '',
                title: t('inventoryLock.type'),
                dataIndex: 'type',
                key:'type',
                width:'160',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            {
                // title: '',
                title: t('inventoryLock.availableQTY'),
                dataIndex: 'quantity',
                key:'quantity',
                width:'150',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            {
                // title: '',
                title: t('inventoryLock.currentQTY'),
                dataIndex: 'current_quantity',
                key:'current_quantity',
                width:'150',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            {
                // title: '',
                title: t('inventoryLock.warehouse'),
                dataIndex: 'warehouse_name',
                key:'warehouse_name',
                width:'120',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            {
                // title: '',
                title: t('inventoryLock.ETA'),
                dataIndex: 'eta',
                key:'eta',
                width:'220',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            {
                // title: '',
                title: t('inventoryLock.batchId'),
                dataIndex: 'batch_id',
                key:'batch_id',
                width:'220',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            // {
            //     // title: '',
            //     title: t('inventoryLock.isOccupy'),
            //     dataIndex: 'over_status',
            //     key:'over_status',
            //     width:'220',
            //     ellipsis:true,
            //     tooltip:true,
            //     align:'left',
            // },
        ],
        configs:{
            scroll:{
                // x:1000,
                y:650,
            },
            // rowClass:(record, rowIndex)=>{
            //     console.log(record, rowIndex, 'record, rowIndex')
            //     return 'red_bg' // record.over_status == 1? 'red_bg' : 'white_bg'
            // },
            stripe:true,
            bordered:true,
            size:'large',
            loading:false,
            expandable:'',
            expand:false,
            pagination:false,
        },
    })

    const editLockTable = ref({
        datas:[],
        columns:[
            {
                title: '#',
                dataIndex: 'No',
                key:'No',
                width:'60',
                fixed:'left',
                align:'left',
            },
            {
                // title: '',
                title: t('inventoryLock.sku'),
                dataIndex: 'sku',
                key:'sku',
                width:'190',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            {
                // title: '',
                title: t('inventoryLock.type'),
                dataIndex: 'inventory_type',
                key:'inventory_type',
                width:'200',
                ellipsis:true,
                tooltip:true,
                align:'left',
                slotName:'slot',
            },
            {
                // title: '',
                title: t('inventoryLock.estimatedShippingDate'),
                dataIndex: 'plan_timestamp',
                key:'plan_timestamp',
                width:'220',
                ellipsis:true,
                tooltip:true,
                align:'left',
                slotName:'slot',
            },
            {
                // title: '',
                title: t('inventoryLock.warehouse'),
                dataIndex: 'warehouse',
                key:'warehouse',
                width:'220',
                ellipsis:true,
                tooltip:true,
                align:'left',
                slotName:'slot',
            },
            {
                // title: '',
                title: t('inventoryLock.batchId'),
                dataIndex: 'batch_id',
                key:'batch_id',
                width:'300',
                ellipsis:true,
                tooltip:true,
                align:'left',
                slotName:'slot',
            },
            {
                // title: '',
                title: t('inventoryLock.availableQTY'),
                dataIndex: 'available_quantity',
                key:'available_quantity',
                width:'130',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            {
                // title: '',
                title: t('inventoryLock.estimatedShippingDateByCustomer'),
                dataIndex: 'need_plan_timestamp',
                key:'need_plan_timestamp',
                width:'300',
                ellipsis:true,
                tooltip:true,
                align:'left',
                slotName:'slot',
            },
            {
                // title: '',
                title: t('inventoryLock.currentLockedQTY'),
                dataIndex: 'quantity',
                key:'quantity',
                width:'180',
                ellipsis:true,
                tooltip:true,
                align:'left',
                slotName:'slot',
            },
            {
                // title: '',
                title: t('inventoryLock.shippingQTY'),
                dataIndex: 'reserved_quantity',
                key:'reserved_quantity',
                width:'150',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            {
                // title: '',
                title: t('inventoryLock.totalLockedQTY'),
                dataIndex: 'locked_quantity',
                key:'locked_quantity',
                width:'150',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            {
                // title: '',
                title: t('inventoryLock.locked'),
                dataIndex: 'lock_status',
                key:'lock_status',
                width:'120',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            {
                title: t('base.operate'),
                dataIndex: 'Optional',
                key:'Optional',
                slotName:'optional',
                width:'100',
                align:'center',
                fixed:'right'
            }
        ],
        configs:{
            scroll:{
                // x:1000,
                y:650,
            },
            stripe:true,
            bordered:true,
            size:'large',
            loading:false,
            expandable:'',
            expand:false,
            pagination:false,
        },
    })

    const inventoryType = ref({
        in_stock:'In Stock',
        in_transit:'In Transit',
        production_plan:'Production Plan',
    })

    const inventoryTypeOptions = ref([
        // {
        //     label: t('inventoryLock.inStock'),
        //     value:'in_stock',
        //     // disabled:true
        // },
        // {
        //     label: t('inventoryLock.inTransit'),
        //     value:'in_transit'
        // },
        // {
        //     label: t('inventoryLock.productionPlan'),
        //     value:'production_plan'
        // }
    ])

    const planTimestampOptions = ref([])
    const warehouseOptions = ref([])

    const handle = async (type, row)=>{
        switch(type){
            case 'search':
                getList()
                break;
            case 'reset':
                queryForm.formField.forEach(item=>{
                    queryForm.formData[item.key] = ''
                })
                getList()
                break;
            case 'refreshList':
                getList()
                break;
            case 'edit':
                editVisible.value = true
                rowData.value = row
                order_no.value = ''
                editTable.value.datas = []
                editLockTable.value.datas = []
                getAvailableInventoryListBySKU(row)
                getOrderBySKU(row)
                break;
            case 'view':
                visible.value = true
                viewTable.value.configs.pagination.current = 1
                rowData.value = row
                queryForm2.formData.lock_status = 1
                getViewList(row)
                break;
            case 'refresh':
                if(order_no.value == '') await getAvailableInventoryListBySKU(rowData.value)
                else await getLockAvailableBySKU(rowData.value)


                for(let i=0; i<editTable.value.datas.length; i++){
                    let item = editTable.value.datas[i]
                    for(let m=0; m<editLockTable.value.datas.length; m++){
                        let m_item = editTable.value.datas[m]
                        if(m_item.one_flag == item.one_flag){
                            m_item.available_quantity = item.quantity
                        }
                    }
                }
                break;
            case 'editInventoryLock':
                editLockTable.value.datas.forEach(i=>{
                    i.edit_disabled = false
                    if(i.line_type !== 'add'){
                        i.disabled1 = i.reserved_quantity > 0
                        i.disabled2 = i.reserved_quantity > 0
                        i.disabled3 = i.reserved_quantity > 0
                        i.disabled4 = i.reserved_quantity > 0
                    }
                    editTable.value.datas.forEach(m=>{
                        if(m.one_flag == i.one_flag) i.available_quantity = m.quantity + m.current_quantity
                    })
                })
                break;
            case 'unlockInventory':
                unlock()
                break;
            case 'addLockLine':
                editLockTable.value.datas.push({
                    No: editLockTable.value.datas.length + 1,
                    sku: rowData.value.sku,
                    inventory_type: '',
                    plan_timestamp: '',
                    warehouse: '',
                    available_quantity: '',
                    need_plan_timestamp: '',
                    quantity: 0,
                    reserved_quantity: 0,
                    locked_quantity: 0,
                    lock_status: t('base.YES'),
                    edit_disabled: false,
                    disabled1: false,
                    disabled2: true,
                    disabled3: true,
                    disabled4: true,
                    line_type:'add',
                    batch_id:'',
                })
                break;
        }
    }

    const handlePressEnter = ()=>{
        getList()
    }

    const changePage = (current)=>{
        viewTable.value.configs.pagination.current = current
        getViewList(rowData.value)
    }

    const changePageSize = (pageSize)=>{
        viewTable.value.configs.pagination.current = 1
        viewTable.value.configs.pagination.pageSize = pageSize
        getViewList(rowData.value)
    }

    const handleViewSelectChange = ()=>{
        viewTable.value.configs.pagination.current = 1
        getViewList(rowData.value)
    }

    const handleViewPressEnter = ()=>{
        viewTable.value.configs.pagination.current = 1
        getViewList(rowData.value)
    }

    const handleViewInputClear = ()=>{
        viewTable.value.configs.pagination.current = 1
        getViewList(rowData.value)
    }

    const changeOrderNo = async (val)=>{
        // console.log(val,'valll')
        let item = orderOptions.value.find(i=> i.value == val)
        // console.log(item,'kk item', val)
        order_line_id.value = item.order_line_id
        total_quantity.value = item.quantity
        open_quantity.value = item.open_quantity
        await getLockAvailableBySKU(rowData.value)
    }

    const changeDate = (val, row)=>{
        // console.log(val,';vbbbbb')
        row.need_plan_timestamp = dateToTimestamp(val) * 1000
    }

    const changeQuantity = (val, row)=>{
        // console.log(val, row,'qty')
        if(val > row.available_quantity){
            Modal.warning({
                title: t('base.tip'),
                titleAlign:'start',
                hideCancel:true,
                content:t('inventoryLock.currentLockedQTYTip'), 
                width: 550,
                okText:t('base.ok'),
                cancelText:t('base.cancel'),
                onOk:()=>{
                    val = ''
                    row.quantity = ''
                }
            })
            return
        }
        row.locked_quantity = val + row.reserved_quantity
    }

    const changeInventoryType = (val, row)=>{
        // console.log(val, row, 'changeInventoryType')
        row.inventory_type_val = val
        row.disabled2 = false
        row.plan_timestamp = ''
        row.warehouse = ''
        row.batch_id = ''
        row.available_quantity = ''
        row.planTimestampOptions = []
        row.warehouseOptions = []
        row.batchIdOptions = []

        for(let key in type_plan_wms.value[val]){
            row.planTimestampOptions.push({
                label: timestampToDate(Number(key) * 1000).split(' ')[0],
                value: key,
            })
        }

        // console.log(row.planTimestampOptions,'row.planTimestampOptions')
    }

    const changePlanTimestamp = (val, row)=>{
        // console.log(val, row, 'changePlanTimestamp')
        row.disabled3 = false
        row.warehouse = ''
        row.batch_id = ''
        row.need_plan_timestamp = val * 1000
        row.available_quantity = ''
        row.warehouseOptions = []
        row.batchIdOptions = []

        for(let key in type_plan_wms.value[row.inventory_type_val][val]){
            row.warehouseOptions.push({
                label: key == 'HFFG05'? 'Central Warehouse' : key == 'HFFG01'? 'Maisach' : key,
                value: key,
            })
        }
    }

    const changeWarehouse = (val, row)=>{
        row.disabled4 = false
        row.batch_id = ''
        row.available_quantity = ''
        row.batchIdOptions = []

        for(let key in type_plan_wms.value[row.inventory_type_val][row.plan_timestamp][val]){
            row.batchIdOptions.push({
                label: key,
                value: key,
            })
        }
    }

    const changeBatchId = (val, row)=>{
        // console.log(val, row, 'changeWarehouse 222')
        row.available_quantity = ''
        let arr = []
        row.one_flag = `${row.inventory_type_val}${timestampToDate(row.plan_timestamp * 1000).split(' ')[0]}${row.warehouse}${row.batch_id}`

        for(let i=0; i<editLockTable.value.datas.length; i++){
            let item = editLockTable.value.datas[i]
            if(!arr.includes(item.one_flag)){
                arr.push(item.one_flag)
                let m_item = editTable.value.datas.find(k=> k.one_flag == row.one_flag)
                if(m_item){
                    row.available_quantity = m_item.quantity + m_item.current_quantity
                    row.batch_id = m_item.batch_id
                } 
            }else{
                Message.error({
                    content: t('inventoryLock.sameData'),
                    duration: 3000,
                })
                row.batch_id = ''
                row.available_quantity = ''
                return
            }
        }
    }

    

    const disabledDate = (current, row)=>{
        // console.log(row.plan_timestamp, 'ggg', row.need_plan_timestamp)
        let everyDay_timestamp = dateToTimestamp(timestampToDate(new Date(current).getTime()).split(' ')[0]) // 日期组件每天日期
        return everyDay_timestamp < row.plan_timestamp
    }

    const handleDeleteLine = (row)=>{
        editLockTable.value.datas.splice(row.No - 1, 1)
    }

    // 导出
    const exportFile = async ()=>{
        Message.success(t('base.exporting'))
        exporting.value = true
        table.value.configs.loading = true

        let res = await InventoryLockApi.getInstance().exportData()
        if(!res.code){
            let blob = new Blob([res])
            let a = document.createElement('a')
            a.href = URL.createObjectURL(blob)
            a.download =  `${t('inventoryLock.inventoryLockData')}.xlsx`
            a.style.display = 'none'
            document.body.appendChild(a)
            a.click()
            URL.revokeObjectURL(a.href)
            document.body.removeChild(a)

            setTimeout(()=>{
                Message.success(t('base.exportSuccess'))
                exporting.value = false
                table.value.configs.loading = false
            }, 1500)
        }else{  
            Message.error(res.msg)
        }
    }

    // 获取库存锁定列表
    const getList = async ()=>{
        table.value.configs.loading = true
        let res = await InventoryLockApi.getInstance().getList()
        if(res.code == 0){
            res.data.forEach((item,index)=>{
                item.No = index + 1

            })
            table.value.datas = res.data
            table.value.configs.loading = false
            
        }else{
            Message.error(res.msg)
        }
    }

    // 获取库存锁定信息列表
    const getViewList = async (row)=>{
        let param = {
            sku: row.sku,
            ...queryForm2.formData,
        }

        let page_num = viewTable.value.configs.pagination.current
        let page_size = viewTable.value.configs.pagination.pageSize

        viewTable.value.configs.loading = true
        let res = await InventoryLockApi.getInstance().getViewList(param, page_num, page_size)
        if(res.code == 0){
            res.data.records.forEach((item,index)=>{
                item.No = index + 1
                item.locked_quantity = item.locked_quantity == undefined? 0 : item.locked_quantity
                item.quantity = item.quantity == undefined? 0 : item.quantity
                item.reserved_quantity = item.reserved_quantity == undefined? 0 : item.reserved_quantity

                item.lock_status_val = item.lock_status 
                item.lock_status = item.lock_status == 0? t('inventoryLock.overdue') : item.lock_status == 1? t('inventoryLock.locked') : t('inventoryLock.finish')
                item.inventory_type = inventoryType.value[item.inventory_type]
                item.plan_timestamp = item.plan_timestamp == undefined? '-' : timestampToDate(item.plan_timestamp * 1000).split(' ')[0]
                item.need_plan_timestamp = item.need_plan_timestamp == undefined? '-' : timestampToDate(item.need_plan_timestamp * 1000).split(' ')[0]
                item.warehouse = item.warehouse == 'HFFG05'? 'Central Warehouse' : item.warehouse == 'HFFG01'? 'Maisach' : item.warehouse
            })
            viewTable.value.datas = res.data.records
            viewTable.value.configs.pagination.total = res.data.total
            viewTable.value.configs.loading = false
            
        }else{
            Message.error(res.msg)
        }
    }

    // 获取当前sku的库存参考信息
    const getAvailableInventoryListBySKU = async (row)=>{
        let param = {
            sku: row.sku,
        }

        editTable.value.configs.loading = true
        let res = await InventoryLockApi.getInstance().getAvailableInventoryListBySKU(param)
        if(res.code == 0){
            res.data.list.forEach((item,index)=>{
                item.No = index + 1
                item.quantity = item.quantity == undefined? 0 : item.quantity
                item.current_quantity =  item.current_quantity == undefined? 0 : item.current_quantity
                item.type_val = item.type
                item.type = inventoryType.value[item.type]
                item.warehouse = item.warehouse == undefined? '-' : item.warehouse 
                item.warehouse_name = item.warehouse_name == undefined? '-' : item.warehouse_name 
                item.eta = item.eta == undefined? '-' : timestampToDate(item.eta * 1000).split(' ')[0]
                item.one_flag = `${item.type_val}${item.eta}${item.warehouse}${item.batch_id}`,
                item.over_status = item.over_status == undefined? '-' : item.over_status == 1? t('base.YES') : '-'
                item.batch_id = item.batch_id == undefined? '-' : item.batch_id
            })

            editTable.value.datas = res.data.list
            editTable.value.configs.loading = false
        }else{
            Message.error(res.msg)
        }
    }

    // 
    const getLockAvailableBySKU = async (row)=>{
        let param = {
            sku: row.sku,
            order_id: order_no.value,
            lock_status: 1
        }

        editTable.value.configs.loading = true
        let res = await InventoryLockApi.getInstance().getLockAvailableBySKU(param)
        if(res.code == 0){
            res.data.list.forEach((item,index)=>{
                item.No = index + 1
                item.quantity = item.quantity == undefined? 0 : item.quantity
                item.type_val = item.type
                item.type = inventoryType.value[item.type]
                item.warehouse = item.warehouse == undefined? '-' : item.warehouse 
                item.warehouse_name = item.warehouse_name == undefined? '-' : item.warehouse_name 
                item.eta = item.eta == undefined? '-' : timestampToDate(item.eta * 1000).split(' ')[0]
                item.one_flag = `${item.type_val}${item.eta}${item.warehouse}${item.batch_id}`
                item.over_status = item.over_status? item.over_status : ''
                item.over_status = item.over_status == undefined? '-' : item.over_status == 1? t('base.YES') : '-'
                item.batch_id = item.batch_id == undefined? '-' : item.batch_id
            })

            inventoryTypeOptions.value = []
            for(let key in res.data.map){
                inventoryTypeOptions.value.push({
                    label: inventoryType.value[key],
                    value: key,
                }) 
            }

            type_plan_wms.value = res.data.map
            editTable.value.datas = res.data.list
            editTable.value.configs.loading = false

            // 获取当前sku在之前保存的库存占用信息
            if(type_plan_wms.value){
                res.data.records.forEach((item,index)=>{
                    item.No = index + 1
                    item.locked_quantity = item.locked_quantity == undefined? 0 : item.locked_quantity
                    item.quantity = item.quantity == undefined? 0 : item.quantity
                    item.reserved_quantity = item.reserved_quantity == undefined? 0 : item.reserved_quantity

                    item.inventory_type_val = item.inventory_type
                    item.inventory_type = item.inventory_type
                    item.plan_timestamp = item.plan_timestamp == undefined? '' : item.plan_timestamp
                    item.need_plan_timestamp = item.need_plan_timestamp == undefined? '' : item.need_plan_timestamp * 1000
                    item.warehouse = item.warehouse
                    item.available_quantity = ''

                    item.one_flag = `${item.inventory_type_val}${timestampToDate(item.plan_timestamp * 1000).split(' ')[0]}${item.warehouse}${item.batch_id}`

                    item.lock_status = item.lock_status == undefined? '-' : item.lock_status == 1? t('base.YES') : t('base.NO')
                    item.disabled1 = true
                    item.disabled2 = true
                    item.disabled3 = true
                    item.disabled4 = true
                    item.edit_disabled = true
                    item.delete_disabled = item.inventory_type_val == 'in_stock' && item.reserved_quantity > 0
                
                    item.planTimestampOptions = []
                    item.warehouseOptions = []
                    item.batchIdOptions = []

                    for(let key in type_plan_wms.value[item.inventory_type_val]){
                        item.planTimestampOptions.push({
                            label: timestampToDate(Number(key) * 1000).split(' ')[0],
                            value: Number(key),
                        })
                    }

                    for(let key in type_plan_wms.value[item.inventory_type_val][item.plan_timestamp]){
                        item.warehouseOptions.push({
                            label: key == 'HFFG05'? 'Central Warehouse' : key == 'HFFG01'? 'Maisach' : key,
                            value: key,
                        })
                    }

                    for(let key in type_plan_wms.value[item.inventory_type_val][item.plan_timestamp][item.warehouse]){
                        item.batchIdOptions.push({
                            label: key[0].batch_id,
                            value: key,
                        })
                    }

                    
                })

                editLockTable.value.datas = res.data.records
                editLockTable.value.configs.loading = false

                // console.log(editLockTable.value.datas, 'kjkj')
            } 
            // getLockList(rowData.value)
        }else{
            Message.error(res.msg)
        }
    }

    // 获取当前sku在之前保存的库存占用信息
    const getLockList = async (row)=>{
        let param = {
            sku: row.sku,
            order_id: order_no.value,
            lock_status: 1
        }

        editLockTable.value.configs.loading = true
        let res = await InventoryLockApi.getInstance().getLockList(param)
        if(res.code == 0){
            res.data.forEach((item,index)=>{
                item.No = index + 1
                item.locked_quantity = item.locked_quantity == undefined? 0 : item.locked_quantity
                item.quantity = item.quantity == undefined? 0 : item.quantity
                item.reserved_quantity = item.reserved_quantity == undefined? 0 : item.reserved_quantity

                item.inventory_type_val = item.inventory_type
                item.inventory_type = item.inventory_type
                item.plan_timestamp = item.plan_timestamp == undefined? '' : item.plan_timestamp
                item.need_plan_timestamp = item.need_plan_timestamp == undefined? '' : item.need_plan_timestamp * 1000
                item.warehouse = item.warehouse
                item.available_quantity = ''

                item.one_flag = `${item.inventory_type_val}${timestampToDate(item.plan_timestamp * 1000).split(' ')[0]}${item.warehouse}${item.batch_id}`

                item.lock_status = item.lock_status == undefined? '-' : item.lock_status == 1? t('base.YES') : t('base.NO')
                item.disabled1 = true
                item.disabled2 = true
                item.disabled3 = true
                item.disabled4 = true
                item.edit_disabled = true
                item.delete_disabled = item.inventory_type_val == 'in_stock' && item.reserved_quantity > 0
            
                item.planTimestampOptions = []
                item.warehouseOptions = []
                item.batchIdOptions = []

                for(let key in type_plan_wms.value[item.inventory_type_val]){
                    item.planTimestampOptions.push({
                        label: timestampToDate(Number(key) * 1000).split(' ')[0],
                        value: Number(key),
                    })
                }

                for(let key in type_plan_wms.value[item.inventory_type_val][item.plan_timestamp]){
                    item.warehouseOptions.push({
                        label: key[0].warehouse_name,
                        value: key,
                    })
                }

                for(let key in type_plan_wms.value[item.inventory_type_val][item.plan_timestamp][item.warehouse]){
                    item.batchIdOptions.push({
                        label: key[0].batch_id,
                        value: key,
                    })
                }
            })

            editLockTable.value.datas = res.data
            editLockTable.value.configs.loading = false

            // console.log(editLockTable.value.datas,'mmmm')
            
        }else{
            Message.error(res.msg)
        }
    }

    const handleCancel = ()=>{
        editVisible.value = false
        order_no.value = ''
        editTable.value.datas = []
        editLockTable.value.datas = []
    }

    const handleOk = ()=>{
        // console.log(editTable.value.datas, 'editTable')
        // console.log(editLockTable.value.datas, 'editLockTable')
       
        let totalQty = 0
        for(let i=0; i<editLockTable.value.datas.length; i++){
            let item = editLockTable.value.datas[i]
            totalQty += item.locked_quantity

            if(!item.inventory_type){
                Message.error(t('inventoryLock.inventoryType')+ ' ' + t('base.noEmpty'))
                return
            }else if(!item.plan_timestamp){
                Message.error(t('inventoryLock.estimatedShippingDate')+ ' ' + t('base.noEmpty'))
                return
            }else if(!item.warehouse){
                Message.error(t('inventoryLock.warehouse')+ ' ' + t('base.noEmpty'))
                return
            }else if(!item.need_plan_timestamp){
                Message.error(t('inventoryLock.estimatedShippingDateByCustomer')+ ' ' + t('base.noEmpty'))
                return
            }else if(item.quantity === ''){
                Message.error(t('inventoryLock.currentLockedQTY')+ ' ' + t('base.noEmpty'))
                return
            }else if(item.reserved_quantity == 0 && item.quantity == 0){
                Message.error(t('inventoryLock.currentLockedQTY2')+ ' ' + t('base.noEmpty'))
                return
            }
        }

        if(totalQty > total_quantity.value){
            Modal.warning({
                title: t('base.tip'),
                titleAlign:'start',
                hideCancel:true,
                content:t('inventoryLock.shipInStockTip2'), 
                width: 450,
                okText:t('base.ok'),
                cancelText:t('base.cancel'),
                onOk:()=>{}
            })
            return
        } 

        saveInventoryLock()

        // editTable.value.datas.forEach(i=>{
        //     i.flag = `${i.type_val}${i.warehouse}${i.batch_id}`
        // })
        // editLockTable.value.datas.forEach(i=>{
        //     i.flag = `${i.inventory_type_val}${i.warehouse}${i.batch_id}`
        // })
        // console.log(editTable.value.datas, 'editTable')
        // console.log(editLockTable.value.datas, 'editLockTable')
        

        // for(let i=0; i<editLockTable.value.datas.length; i++){
        //     let item = editLockTable.value.datas[i]

        //     for(let k=0; k<editTable.value.datas.length; k++){
        //         let item2 = editTable.value.datas[k]
        //         console.log(item.flag == item2.flag, 'flag')

        //         if(item.flag == item2.flag){
        //             if(timestampToDate(item.plan_timestamp * 1000).split(' ')[0] != item2.eta){
        //                 Message.error(`【row ${i + 1}】` + t('inventoryLock.etaTip'))
        //                 return
        //             }
        //         }
        //     }
        // }
        
    }

    // 保存锁定库存
    const saveInventoryLock = async ()=>{
        let param = []
        editLockTable.value.datas.forEach(i=>{
            if(i.line_type == 'add'){
                param.push({
                    batch_id: i.inventory_type_val == 'in_stock'? '' : i.batch_id,
                    sku: rowData.value.sku,
                    quantity: i.locked_quantity,
                    inventory_type: i.inventory_type_val,
                    plan_timestamp: i.plan_timestamp,
                    need_plan_timestamp: i.need_plan_timestamp.toString().length > 10? Number(i.need_plan_timestamp.toString().substring(0,10)) : i.need_plan_timestamp,
                    warehouse: i.warehouse,
                    reserved_quantity: i.reserved_quantity,
                })
            }else{
                param.push({
                    id: i.id,
                    batch_id: i.inventory_type_val == 'in_stock'? '' : i.batch_id,
                    sku: rowData.value.sku,
                    quantity: i.locked_quantity,
                    inventory_type: i.inventory_type_val,
                    plan_timestamp: i.plan_timestamp,
                    need_plan_timestamp: i.need_plan_timestamp.toString().length > 10? Number(i.need_plan_timestamp.toString().substring(0,10)) : i.need_plan_timestamp,
                    warehouse: i.warehouse,
                    reserved_quantity: i.reserved_quantity,
                })
            }
            
        })
        
        console.log(param, 'param')

        let res = await InventoryLockApi.getInstance().saveInventoryLock(param, order_line_id.value)
        if(res.code == 0){
            editVisible.value = false
        }else{
            Message.error(res.msg)
        }
    }

    // 解除当前sku下的库存锁定
    const unlock = async ()=>{
        let res = await InventoryLockApi.getInstance().unlock(order_line_id.value)
        if(res.code == 0){
            if(res.data){
                Modal.warning({
                    title: t('base.tip'),
                    titleAlign:'start',
                    hideCancel:true,
                    content:t('inventoryLock.unlockedTip'), 
                    width: 450,
                    okText:t('base.ok'),
                    cancelText:t('base.cancel'),
                    onOk:()=>{}
                })
            }else{
                // getLockList(rowData.value)
                getLockAvailableBySKU(rowData.value)
            }
        }else{
            Message.error(res.msg)
        }
    }

    // 获取当前sku下的订单
    const getOrderBySKU = async (row)=>{
        let param = {
            sku: row.sku,
        }

        let res = await InventoryLockApi.getInstance().getOrderBySKU(param)
        if(res.code == 0){
            orderOptions.value = []
            res.data.forEach((item,index)=>{
                orderOptions.value.push({
                    label: item.order_name,
                    value: item.order_id,
                    order_line_id: item.order_line_id,
                    quantity: item.quantity,
                    open_quantity: item.open_quantity,
                })
            })
            
        }else{
            Message.error(res.msg)
        }
    }


    onMounted(()=>{
        getList()
    })
</script>

<style lang="less" scoped>
.queryPanel{
    display: flex;
    // margin-bottom:7px;
    padding:7px;
    background: #fff;
    border-bottom: 1px dashed #ccc;

    .queryPanel_form{
        display: flex;
        flex:14;
        flex-direction: column;
        height: 33px;
        overflow: hidden;

        /deep/ .arco-form-layout-inline .arco-form-item{
            margin-bottom:0;
        }
    }

    .queryPanel_form_show{
        height: auto;
        overflow: visible;
    }

    .queryPanel_btn{
        display: flex;
        flex:1;
        // flex-direction: column;
        justify-content: center;
        align-items: center;
        border-left:1px solid #eee;
        padding-left:5px;

        .openBtn{
            display: inline-block;
            padding: 3px 10px;
            margin: 2px 5px 0 5px;
            width: 80px;
            text-align: center;
            color: #165dff;
            cursor: pointer;
            border: 1px solid #165dff;
            border-radius:2px;
        }
    }

    /deep/ .arco-form-item-label-col > .arco-form-item-label{
        font-size:12px;
    }

    /deep/ .arco-form-item-layout-inline{
        margin-right: 0;
    }

    .form_btn{
        margin:5px 5px 3px;
        width:70px;
    }
}


/deep/ .operayeBox {
    margin-bottom: 7px;
    background: #fff;
    padding: 5px 24px 5px 5px;
}

.tableTitle{
    font-weight: bold;
}

/deep/ .arco-btn-group{
    vertical-align: bottom;
}
/deep/ .arco-btn-group .arco-btn:first-child,
/deep/ .arco-btn-group .arco-btn:last-child{
    background: #165dff;
    color: #fff;
}

/deep/ .arco-table-td{
    border-right: 1px solid #eee;
}

/deep/ .arco-table-th{
    background: #fff;
    border-bottom: 1px solid #eee;
    border-right: 1px solid #eee;
    font-size: 13px;
    font-weight: 600;
}

/deep/ .arco-table-cell{
    padding:8px 16px !important;
}

/deep/ .arco-table-container{
    padding-bottom:0;
}

.searchFilter{
    padding: 20px;
    background: #fff;
    box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.12), 0px 15px 35px 0px rgba(60, 66, 87, 0.08);
}

.editTable{
    /deep/ .arco-pagination{
        display: none;
    }
}

.toolBar{
    margin: 10px 10px 10px 0;
}

// .red_bg{
//     background: #f8d5d5;
// }

// .white_bg{
//     background: transparent;
// }
</style>